import { render, staticRenderFns } from "./BCXMarkdownPopup.vue?vue&type=template&id=13cc53ba&scoped=true"
import script from "./BCXMarkdownPopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./BCXMarkdownPopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BCXMarkdownPopup.vue?vue&type=style&index=0&id=13cc53ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cc53ba",
  null
  
)

export default component.exports